import React, { useState } from "react";
import UserCard from "../users/UserCard";
import Button from "react-bootstrap/Button";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ModalClose from "../modals/ModalClose";
import Modal from "react-bootstrap/Modal";

function SelectUser(props) {

    let { users, currentUser={}, show } = props;
    const [hoveredUser, setHoveredUser] = useState(null);
    // also in props: onSelectUser, onCancel

    const renderUserGallery = () => {
        return (
            <div className={'gallery m-4'}>
                <Row className={'gallery-items align-items-stretch'}>
                    {users.map(user => {
                        return (
                            <Col sm={10} md={4} key={`user-${user.id}`}>
                                <div className={'d-flex flex-column h-100 align-content-stretch'}>
                                    <a
                                        className={`p-1 h-100 border rounded border-${hoveredUser == user || currentUser == user ? 'primary' : 'white'}`}
                                        onClick={() => props.onSelectUser(user)}
                                        onMouseOver={() => setHoveredUser(user)}
                                        onMouseOut={() => setHoveredUser(null)}
                                    >
                                        <UserCard
                                            user={user}
                                            orientation={'vertical'}
                                            nameClasses={'text-medium font-14 fw-light'}
                                            userDetailsClasses={'text-secondary fw-bolder font-15'}
                                            renderAsLink={false} />
                                    </a>
                                    <div className={'mt-1 text-end'}>
                                        <a href={user.url} className={'text-blue-link hover-blue-hover'} target={'_blank'}>
                                            Details
                                            <i className={'fal fa-angle-right ps-1'}></i>
                                        </a>
                                    </div>
                                </div>
                            </Col>
                        )})}
                </Row>
            </div>
        )
    }

    return (
        <Modal
            id={'SelectUser'}
            show={show}
            onHide={() => props.onCancel(false)}
            centered={true}
            size={'lg'}
            contentClassName={'modal-filled bg-white text-secondary'}
            style={{ zIndex: '999999'}}>
            <ModalClose onClose={props.onCancel} />
            <Modal.Header className={'border-bottom-0 pt-4 pb-0 align-self-center text-center w-75'}>
                <Modal.Title className={'fs-5 lh-base'}>Select a different community member who uses {props.productName}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {renderUserGallery()}
            </Modal.Body>
        </Modal>
    )
}

SelectUser.displayName = 'SelectUser';

export default SelectUser;